<script setup lang="ts">
  import { defineProps, onMounted, ref, watch } from 'vue';
  import ButtonAtom from '@/components/atoms/ButtonAtom.vue';

  const props = defineProps<{
    previewData: {
      resource_name: string;
      text_content: string;
      tags: { id: string; value: string }[];
    };
    videoFile: string;
  }>();

  const localPreviewData = ref({ ...props.previewData });

  onMounted(() => {
    localPreviewData.value = props.previewData;
  });
</script>

<template>
  <div>
    <h3 class="preview-title">Preview</h3>
    <div class="video-preview-molecule">
      <div class="preview-header">
        <video v-if="props.videoFile" controls>
          <source :src="props.videoFile" type="video/mp4" />
          <source :src="props.videoFile" type="video/quicktime" />
          Your browser does not support the video element.
        </video>
      </div>
      <div class="preview-content">
        <h1 class="preview-h1">{{ props.previewData.resource_name }}</h1>
        <div v-html="props.previewData.text_content"></div>
        <div class="tags-container">
          <ButtonAtom
            v-for="tag in props.previewData.tags"
            :key="tag.id"
            class="btn btn-secondary tag-button"
          >
            {{ tag.value }}
          </ButtonAtom>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .preview-title {
    text-align: left;
    margin-bottom: 28px;
    font-weight: bold;
    color: var(--color-black);
  }

  .video-preview-molecule {
    display: flex;
    flex-direction: column;
    width: 90%;
    max-width: 800px;
    min-height: 600px;
    margin: auto;
    border-radius: 12px;
    background-color: #fff;
    border: 1px solid var(--color-black);
    padding: 0;
    box-sizing: border-box;
  }

  .preview-header {
    position: relative;
    width: 100%;
    height: 240px;
    overflow: hidden;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    background-color: var(--color-gray-30);
  }

  .preview-header video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
  }

  .preview-h1 {
    margin: 0;
    word-wrap: break-word;
    word-break: break-word;
    overflow-wrap: break-word;
    line-height: 1.2;
    width: 100%;
    box-sizing: border-box;
    text-align: left;
    color: var(--color-black);
  }

  .preview-content {
    padding: 20px;
    overflow-y: auto;
    overflow-x: hidden;
    border-top: 1px solid var(--color-black);
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
    word-wrap: break-word;
    word-break: break-word;
    white-space: pre-wrap;
    text-align: left;
    max-width: 100%;
    box-sizing: border-box;
    font-family: 'Plus Jakarta Sans';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
    color: var(--color-gray);
  }

  .tags-container {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 10px;
  }

  .tag-button {
    border: 1px solid var(--color-black);
    cursor: default;
  }
</style>
